module.exports = __webpack_public_path__ + "assets/icon-right-arrow.de54906d.svg";